import type { MessageKey } from '@/i18n';
import type { PaymentMethodId } from './availability';

/** What each method is called on screen. Shared so the selection and the steps after it agree. */
export const PAYMENT_METHOD_LABEL_KEYS: Record<PaymentMethodId, MessageKey> = {
    card: 'payment.card',
    applePay: 'payment.applePay',
    googlePay: 'payment.googlePay',
};
